import React, { Component } from 'react';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import Chip from 'material-ui/Chip';
import { Form } from 'semantic-ui-react';

import filterOptions from './FilterOptions'

class SearchFilter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filter: {},
      filterOptions,
      searchApplied: false,
      filterApplied: false,
    };
  }

  _updateChanges = () =>  {
    this.props.onApply(this.state.filter);
  }

  _removeEmptyFilters = (filter) => {
    for (let key in filter ) {
      if (filter[key] && filter[key].length === 0) {
        delete filter[key];
      }
    }
    return filter;
  }
  
  handleChange = (event, index, values, name) => {
    const [elem] = values; 
    let nameFilter = this.state.filter[name];
    let newFilter;
    if(nameFilter) {
      newFilter = nameFilter.includes(elem) ? {...this.state.filter, [name]: nameFilter.filter(el => el !== elem) } : {...this.state.filter, [name]: [elem, ...nameFilter]}
      newFilter = this._removeEmptyFilters(newFilter);
      this.setState({ filter: newFilter, filterApplied: true }, this._updateChanges);
    }
    else {
      newFilter = this._removeEmptyFilters({...this.state.filter, [name]: values});
      this.setState( { filter: newFilter , filterApplied: true }, this._updateChanges)
    }
  }

  handleClear = () => {
    this.setState({ filterApplied: false });
    this.setState({filter: {}});
    this.props.onClear();
  }

  handleChipRequestDelete = (key, value) => {
    this.handleChange(undefined,undefined,[value], key);
  }

  renderChips = () => {
    let chips = []
    for (let key in this.state.filter) {
      chips.push(this.state.filter[key].map(value => 
        <Chip
          onRequestDelete={() => this.handleChipRequestDelete(key, value)}
          style={{margin:'0px 5px'}}
        >
          {`${key} : ${(key==='price' ? this._convertPriceToSymbol(value) : value)}`}
        </Chip>
    ))}
    return <div className='filter-section-chips'>{chips}</div>;
  }

  _convertPriceToSymbol = (price, symbol='') => {
    for (let i=0; i<price; i++) symbol+='$';
    return symbol;
  }

  menuItems = (name, options) =>
    options.map(item => <MenuItem
      key={item}
      insetChildren
      checked={this.state.filter[name] && this.state.filter[name].includes(item)}
      value={item}
      primaryText={
        name==='price' 
        ? this._convertPriceToSymbol(item)
        : `${item.substr(0, 1).toUpperCase()}${item.substr(1).toLowerCase()}`
      }
    />
  );

  render() {
    return (
      <div>
        <div className='filter-title'>
          <strong>Filter</strong>
        </div>
        <Form>
          <div className='zolando-filters'>
            { this.state.filterOptions.map((option) => 
              <div className='filter-section filter-dropdown' key={option.label}>
              <SelectField
                  multiple
                  hintText={option.label}
                  value={this.state[option.name]}
                  onChange={(event, index, values) => this.handleChange(event, index, values, option.name)}
                >
                  { this.menuItems(option.name, option.options) }
                </SelectField>
              </div>
            ) } 
          </div>

          <div className='filter-section-apply'>
            { this.renderChips() }
            <div className='filter-action-buttons'>
              { this.state.filterApplied && !(Object.entries(this.state.filter).length === 0)
                ? <p className='clear' onClick={ () => this.handleClear() }>Clear All</p>
                : '' 
              }
            </div>
          </div>
        </Form>
      </div>
    )
  }
}
/*<button onClick={ (event) => this.handleApply(event)}>Apply</button>*/
export default SearchFilter;



// WEBPACK FOOTER //
// ./src/components/Zalando/SearchFilter.js